import { Component, OnInit } from '@angular/core';
import { StorageTypeDTO } from '../../../../modules/pick-plan/models/storage-types-dto';
import { MatDialogRef } from '@angular/material/dialog';
import { SessionService } from '../../../../../@core/utils/session.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'storage-details',
  templateUrl: './storage-details.component.html',
  styleUrls: ['./storage-details.component.scss']
})
export class StorageDetailsComponent implements OnInit {
 //#region Properties
 public editActive = false;
 public storageLoading = true;
 public editStorageType: StorageTypeDTO = {};
 public submitting: any;
 //#endregion

  constructor(
    public dialogRef: MatDialogRef<any>,
    private session: SessionService
  ) { }

  ngOnInit() {
    this.editStorageType = this.session.selectedStorageType;
    if (this.editStorageType === null || this.editStorageType === undefined) {
      this.editStorageType = {};
    }
    if (this.editStorageType.id === undefined) {
      this.editStorageType.isActive = true;
      this.storageLoading = false;
    }
  }

  cancelClicked(form: NgForm, cancelled: boolean = false) {
    this.editActive = false;
    this.editStorageType = {};
    form.resetForm();
    this.dialogRef.close(cancelled);
  }

  onSubmit() {
    // Close immediately and let StorageListComponent perform the actual
    // create/update in the background.
    this.submitting = true;
    this.dialogRef.close({
      backgroundSave: true,
      isNew: !this.editStorageType.id,
      storageType: { ...this.editStorageType }
    });
  }

}
